import wpdmIcons from "../../libs/icons";
const {registerBlockType} = wp.blocks;
const {InspectorControls, MediaUpload} = wp.editor;
const {TextControl, SelectControl, FormToggle, ServerSideRender, Modal, Button, PanelBody, IconButton} = wp.components;

const { __ } = wp.i18n;

registerBlockType('download-manager/signin-form', {
    title: 'Login Form',

    description: 'Download Manager Login Form',

    keywords: [
        __( 'download manager signup form digital ecommerce store product sell' ),
        __( 'file manager' ),
        __( 'login signin form' ),
    ],

    icon: wpdmIcons.login(),

    category: 'wpdm-blocks',

    attributes: {
        logo: {
            type: 'string',
            default: ''
        },
        note_before: {
            type: 'string',
            default: ''
        },
        note_after: {
            type: 'string',
            default: ''
        },
        regurl: {
            type: 'string',
            default: ''
        },
        redirect: {
            type: 'string',
            default: ''
        },
        className: {
            type: 'string',
            default: ''
        }
    },

    edit({attributes, className, setAttributes}) {


        function onChangeTemplate(newTemplate) {
            setAttributes({ template: newTemplate });
        }

        function onChangeID(event) {
            if (event.target.value > 0)
                setAttributes({ packageID: event.target.value });
            else if (event.target.id > 0)
                setAttributes({ packageID: event.target.id });
        }

        const captchaToggle = ncaptcha => {
            setAttributes( { captcha: ncaptcha.target.checked } );
        };

        return [

            <InspectorControls>
                <div className="w3eden">
                    <PanelBody>
                    <TextControl
                        label="Redirect URL ( Optional )"
                        help={ 'Where you want to redirect user after login' }
                        value={ attributes.redirect }
                        onChange={ ( url ) => setAttributes( { redirect: url } ) }
                    />
                    <TextControl
                        label="Signup Page URL ( Optional )"
                        help={ 'If you have multiple signup page, you can specify one here' }
                        value={ attributes.redirect }
                        onChange={ ( url ) => setAttributes( { redirect: url } ) }
                    />
                    </PanelBody>
                    <PanelBody title={__('Notes')}>
                        <TextControl
                            label="Before Form:"
                            help={ 'Write if you have any special instructions' }
                            value={ attributes.note_before }
                            onChange={ ( note_before ) => setAttributes( { note_before: note_before } ) }
                        />
                        <TextControl
                            label="After Form:"
                            help={ 'Write if you have any special instructions' }
                            value={ attributes.note_after }
                            onChange={ ( note_after ) => setAttributes( { note_after: note_after } ) }
                        />
                    </PanelBody>
                    <PanelBody title={__('Logo:')}>
                        <MediaUpload
                            onSelect={  img => {
                                setAttributes( {
                                    logo: img.url
                                } )} }
                            type="image"
                            value={ attributes.logo }
                            render={ ( { open } ) => (
                                <div>
                                    <IconButton
                                        className="ab-cta-inspector-media"
                                        label={ __( 'Edit image' ) }
                                        icon="format-image"
                                        onClick={ open }
                                    >
                                        { __( 'Select Image' ) }
                                    </IconButton>

                                    { attributes.logo && !! attributes.logo.length && (
                                        <div>
                                            <img style={{margin: "10px 0", height: "128px", width: 'auto'}} src={attributes.logo} />
                                        <IconButton
                                            className="ab-cta-inspector-media"
                                            label={ __( 'Remove Image' ) }
                                            icon="dismiss"
                                            onClick={ () => {
                                                setAttributes({
                                                    logo: ''
                                                })
                                            } }
                                        >
                                            { __( 'Remove' ) }
                                        </IconButton>
                                        </div>
                                    ) }
                                </div>
                            ) }
                        >
                        </MediaUpload>
                    </PanelBody>
                </div>
            </InspectorControls>
            ,
            <ServerSideRender
                block={"download-manager/signin-form"}
                attributes = {attributes}
                />
            ];
    },
    save() {
        return null;
    }
});
